class MapboxOverlay {

  constructor() {
    this.overlay = document.querySelector('.contact-map__overlay')
    this.listen()
  }

  listen() {
    this.overlay.addEventListener('click',  (ev) => {
      this.overlay.remove()
    })
  }

}

export default MapboxOverlay